import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';

export class DealershipAfterSalesFactory {
    constructor({options, currentMap}){
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const sourceBrands = environment.get('CONFIG.FILTERS.DEALERSHIPS_BRANDS');
        const storeTypes = environment.get('CONFIG.FILTERS.STORE_TYPES');
        const groups = environment.get('CONFIG.FILTERS.GROUPS_NAME');

        return [
            {
                name: 'brands',
                position: 1,
                data: sourceBrands,
                fields: [
                    {
                        title: translate('Common.Brand'),
                        name: 'brands',
                        value: 'id',
                        text: 'name',
                        type: 'multiselect',
                        skipAll: true,
                        orderBy: "name"
                    }
                ]
            },
            {
                name: 'storeTypes',
                position: 2,
                data: storeTypes,
                fields: [
                    {
                        title: translate('Common.TypeOfStore'),
                        name: 'typeOfStore',
                        value: 'id',
                        text: 'nome',
                        type: 'multiselect',
                        skipAll: true,
                        orderBy: "nome"
                    }
                ]
            },
            {
                name: 'groups',
                position: 3,
                data: groups,
                fields: [
                    {
                        title: translate('Common.Group'),
                        name: 'groups',
                        value: 'value',
                        text: 'text',
                        type: 'multiselect',
                        skipAll: true,
                        orderBy: "nome"
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/dealershipAfterSales.factory.js